import { render, staticRenderFns } from "./CompanyDnamic.vue?vue&type=template&id=cfa70670&scoped=true&"
import script from "./CompanyDnamic.vue?vue&type=script&lang=js&"
export * from "./CompanyDnamic.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDnamic.vue?vue&type=style&index=0&id=cfa70670&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa70670",
  null
  
)

export default component.exports